import { render, staticRenderFns } from "./HistoryListLink.vue?vue&type=template&id=3c3e19f6&scoped=true"
import script from "./HistoryListLink.vue?vue&type=script&lang=js"
export * from "./HistoryListLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3e19f6",
  null
  
)

export default component.exports